import { SvgIconProps } from '@material-ui/core';
import React, { FC, forwardRef } from 'react';
import { ReactComponent as MapLocationIconSvg } from './mapLocationIconSvg.svg';
import { ReactComponent as ConstructionIconSvg } from './constructionIcon.svg';
import { ReactComponent as EnergyIconSvg } from './energyIcon.svg';
import { ReactComponent as EngineeringIconSvg } from './engineeringIcon.svg';
import { ReactComponent as TechnologyIconSvg } from './technologyIcon.svg';
import { ReactComponent as WirelessIconSvg } from './wirelessIcon.svg';
import { ReactComponent as LocationIconSvg } from './LocationIconSvg.svg';
import { ReactComponent as ConstructionWhiteIconSvg } from './construction-white-icon.svg';
import { ReactComponent as ConstructionWhiteIconMobileSvg } from './construction-white-icon-mobile.svg';
import { ReactComponent as EnergyWhiteIconSvg } from './energy-white-icon.svg';
import { ReactComponent as EnergyWhiteIconMobileSvg } from './energy-white-icon-mobile.svg';
import { ReactComponent as EngineeringWhiteIconSvg } from './engineering-white-icon.svg';
import { ReactComponent as EngineeringWhiteIconMobileSvg } from './engineering-white-icon-mobile.svg';
import { ReactComponent as TechnologyWhiteIconSvg } from './technology-white-icon.svg';
import { ReactComponent as TechnologyWhiteIconMobileSvg } from './technology-white-icon-mobile.svg';
import { ReactComponent as WirelessWhiteIconSvg } from './wireless-white-icon.svg';
import { ReactComponent as WirelessWhiteIconMobileSvg } from './wireless-white-icon-mobile.svg';
import { ReactComponent as PinIconSvg } from './pin-icon.svg';
import { ReactComponent as WaterIconSvg } from './water-icon.svg';
import { ReactComponent as WaterWhiteIconSvg } from './water-white-icon.svg';
import { ReactComponent as ArrowDownIconSvg } from './arrow-down.svg';

export const MapLocationIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <MapLocationIconSvg ref={ref} {...props} />);
export const ConstructionIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ConstructionIconSvg ref={ref} {...props} />);
export const EnergyIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EnergyIconSvg ref={ref} {...props} />);
export const EngineeringIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EngineeringIconSvg ref={ref} {...props} />);
export const TechnologyIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <TechnologyIconSvg ref={ref} {...props} />);
export const WirelessIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WirelessIconSvg ref={ref} {...props} />);
export const WaterIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WaterIconSvg ref={ref} {...props} />);
export const LocationIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LocationIconSvg ref={ref} {...props} />);
export const ConstructionWhiteIconMobile= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ConstructionWhiteIconMobileSvg ref={ref} {...props} />
));
export const ConstructionWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ConstructionWhiteIconSvg ref={ref} {...props} />
));
export const EnergyWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EnergyWhiteIconSvg ref={ref} {...props} />);
export const EnergyWhiteIconMobile= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <EnergyWhiteIconMobileSvg ref={ref} {...props} />
));
export const EngineeringWhiteIconMobile= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <EngineeringWhiteIconMobileSvg ref={ref} {...props} />
));
export const EngineeringWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <EngineeringWhiteIconSvg ref={ref} {...props} />
));
export const TechnologyWhiteIconMobile= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <TechnologyWhiteIconMobileSvg ref={ref} {...props} />
));
export const TechnologyWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <TechnologyWhiteIconSvg ref={ref} {...props} />);
export const WirelessWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WirelessWhiteIconSvg ref={ref} {...props} />);
export const WirelessWhiteIconMobile= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <WirelessWhiteIconMobileSvg ref={ref} {...props} />
));
export const WaterWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WaterWhiteIconSvg ref={ref} {...props} />);
export const PinIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PinIconSvg ref={ref} {...props} />);
export const ArrowDownIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ArrowDownIconSvg ref={ref} {...props} />);

export { default as constructionMarkIconSvg } from './constructionMarkIcon.svg';
export { default as wirelessMarkIconSvg } from './wirelessMarkIconSvg.svg';
export { default as energyMarkIconSvg } from './energyIconMarkSvg.svg';
export { default as engineeringMarkIconSvg } from './engineeringMarkIconSvg.svg';
export { default as technologyMarkIconSvg } from './technologyMarkIconSvg.svg';
export { default as waterMapIconSvg } from './water-map-icon.svg';
